import { Map, MapRedirect } from '@innovyze/app-am-network/Pages';
import {
	Overview,
	mainPageRoutes as inspectionPageRoutes,
} from '@innovyze/app-am-activities/Pages';
import {
	RehabManagement,
	mainPageRoutes as rehabPageRoutes,
} from '@innovyze/app-am-rehab/Pages';
import {
	RiskManagementList,
	mainPageRoutes as riskPageRoutes,
} from '@innovyze/app-am-risk/Pages';

import InspectionsIcon from '@Components/InspectionsIcon';
import MapIcon from '@Components/MapIcon';
import React from 'react';
import RehabIcon from '@Components/RehabIcon';
import RiskIcon from '@Components/RiskIcon';
import { TFunc } from '../i18n/types';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { Launcher, LauncherPage } from '@Pages/Launcher';
import AnalysisIcon from '@Components/AnalysisIcon';

//TODO : When adding a new module add the routes here, copied from the module App.tsx. You may need to also copy the icon to the components directory

export const useMapDefaultRoutes = (t: TFunc) => {
	const assetGrid = useIsFeatureEnabled('map-asset-grid');
	return [
		{
			title: t('Home', { context: 'Home default sidebar' }),
			to: '/',
			render: <MapRedirect />,
		},
		// We had to copy this from the module rather than use the mainPageRoutes for the translation to work
		{
			// only show the network text if the asset grid feature flag is enabled
			title: assetGrid
				? t('Network', {
						context: 'map side nav',
				  })
				: t('Map', {
						context: 'map side nav',
				  }),
			to: '/map',
			path:
				'/map/:background?/:center?/:zoom?/:selectedItems?/:hiddenLayers?',
			icon: <MapIcon />,
			render: <Map />,
		},
	];
};

export const useActivitiesMainDefaultRoute = (t: TFunc) => {
	return [
		{
			title: t('Activities', { context: 'Activities side nav' }),
			to: '/',
			icon: <InspectionsIcon />,
			render: <Overview />,
			altHighlight: [
				'/inspections/:standard',
				'/inspections/details/:standard/:inspectionId',
				'/inspections/details/:standard/edit/:inspectionId/:observationId',
				'/inspections/upload/:standard',
				'/inspections/assetDetails/:standard/:assetId',
				'/inspections/tasks/:standard',
				'/inspections/newTask',
				'/inspections/inspections/tasks/details/:taskType/:taskId',
				'/inspections/events/:standard',
				'/inspections/newEvent',
				'/inspections/events/details/:taskType/:taskId',
			],
		},
	];
};

export const useActivitiesMainRoute = (t: TFunc) => {
	return [
		{
			title: t('Activities', {
				context: 'Activities side nav',
			}),
			to: '/inspections',
			icon: <InspectionsIcon />,
			render: <Overview />,
			altHighlight: [
				'/inspections/:standard',
				'/inspections/details/:standard/:inspectionId',
				'/inspections/details/:standard/edit/:inspectionId/:observationId',
				'/inspections/upload/:standard',
				'/inspections/assetDetails/:standard/:assetId',
				'/inspections/tasks/:standard',
				'/inspections/newTask',
				'/inspections/inspections/tasks/details/:taskType/:taskId',
				'/inspections/events/:standard',
				'/inspections/newEvent',
				'/inspections/events/details/:taskType/:taskId',
			],
		},
	];
};

export const inspectionsRoutes = inspectionPageRoutes;

export const useRiskRoutes = (t: TFunc, hide: boolean) => {
	return [
		{
			title: hide ? undefined : t('Risk', { context: 'Risk asset side nav' }),
			to: '/risk',
			icon: hide ? undefined : <RiskIcon />,
			render: <RiskManagementList />,
			altHighlight: [
				'/risk/results',
				'/risk/lofSetup',
				'/risk/cofSetup',
				'/risk/riskSetup',
				'/risk/riskLog',
				'/risk/riskAssetDetails/:assetId',
				'/risk/riskInspectionDetails/:standard/:inspectionId',
			],
		},
		...riskPageRoutes,
	];
};

export const useRehabRoutes = (t: TFunc, hide: boolean) => {
	return [
		{
			title: hide ? undefined : t('Rehab', { context: 'Rehab asset side nav' }),
			to: '/rehab',
			icon: hide ? undefined : <RehabIcon />,
			render: <RehabManagement />,
			altHighlight: ['/rehab/details/:treeId', '/rehab/new'],
		},
		...rehabPageRoutes,
	];
};

export const useVenusRoutes = () => {
	return [
		{
			// No title or icon since we just want the module loaded but not added to the side bar
			to: '/venus',
			render: <></>,
			altHighlight: [
			],
		},
	];
};

export const useLauncherRoutes = (t: TFunc) => {
	return [
		{
			title: t('Analysis', { context: 'Analysis side nav' }),
			to: '/analysis',
			icon: <AnalysisIcon />,
			render: <Launcher page={LauncherPage.Analysis} />,
			altHighlight: [
				'/risk',
				'/risk/results',
				'/risk/lofSetup',
				'/risk/cofSetup',
				'/risk/riskSetup',
				'/risk/riskLog',
				'/risk/riskAssetDetails/:assetId',
				'/risk/riskInspectionDetails/:standard/:inspectionId',
				'/rehab',
				'/rehab/details/:treeId', 
				'/rehab/new',
				'/venus',
			],
		},
	];
};
